export default {"src":"/_next/static/media/SalesIconRed.86389def.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};